@if (shouldShowRebrandedRegimenProposition) {
  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100" *ngIf="loading">
    <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
  </div>
  <section class="tw-flex tw-flex-col tw-h-full" [ngClass]="{ 'tw-bg-teal-100': selectedPlan === 'advance' || selectedPlan === 'introductory', 'tw-bg-orange-100': selectedPlan === 'pro', 'tw-bg-blue-100': selectedPlan === 'assist'}" *ngIf="!loading">
    <section class="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-min-h-0">
      <section class="tw-bg-black">
        <section class="tw-pt-[13px] tw-pb-[11px] tw-px-6 tw-mb-[10px]">
          <div class="tw-absolute tw-left-[34px] tw-top-3" (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
          </div>
          <p class="tw-font-body tw-text-white tw-text-400 tw-w-max tw-m-auto" i18n="@@chooseTreatmentPlan">Choose treatment plan</p>
        </section>
        <toolbar-tabs #toolbarTabs=""
                      (tabSelected)="tabChange($event)"
                      [data]="tabData"
                      [ngClass]="{'planInfo': true, 'tw-bg-black': tabData?.count === 3}">
          <tab1 class="tw-uppercase tw-font-bold">
            <span [ngClass]="{'tw-text-white tw-font-bold': tabData?.count === 4}">{{getVariantPrice(0)}}</span>
          </tab1>
          <tab2 class="tw-uppercase tw-font-bold">
            <span [ngClass]="{'tw-text-white': tabData?.count === 4}">{{getVariantPrice(1)}}</span>
          </tab2>
          <tab3 *ngIf="tabData?.count >= 3" class="tw-uppercase tw-font-bold" [ngClass]="{'tw-px-3': tabData?.count === 3}">
            <span [ngClass]="{'tw-text-white': tabData?.count === 4}">{{getVariantPrice(2)}}</span>
          </tab3>
          <tab4 *ngIf="tabData?.count === 4" class="tw-uppercase tw-font-bold">
            <span class="tw-text-white">{{getVariantPrice(3)}}</span>
          </tab4>
        </toolbar-tabs>
      </section>
      <section class="tw-w-full">
        <section class="tw-w-full">
          <p class="tw-font-lexend tw-font-semibold tw-text-gray-800 tw-pt-3 tw-pl-4" i18n="@@yourTreatmentPlanIncludes">Your&nbsp;<span>₹{{regimenPriceBasedOnSelectedPlan}}</span>&nbsp;treatment plan includes</p>
          <section class="tw-p-4 tw-pr-7 tw-bg-white tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mx-4 tw-my-2 tw-shadow-z4 tw-rounded-2" *ngFor="let item of currentPlanInfo.items; let i = index;">
            @if (item.id === planInfoItemId.PRODUCTS) {
              <div class="tw-w-16 tw-h-16 tw-rounded-full tw-overflow-hidden tw-flex-none">
                <img class="tw-w-full tw-h-full tw-scale-[1.4]" style="object-fit: contain; object-position: center;" [src]="regimenCoverImage" alt="regimenCover" />
              </div>
            } @else if (item.id === planInfoItemId.DEDICATED_DOCTOR || item.id === planInfoItemId.ONE_ON_ONE_DOCTOR) {
              <div class="tw-relative tw-w-16 tw-h-16 tw-rounded-full tw-overflow-hidden tw-bg-gray-100">
                <img class="tw-block tw-absolute tw-top-[5px] tw-left-[5px] tw-w-[52px] tw-h-16 tw-rounded-full" [src]="doctorImageUrl" alt="doctorThumbnail" />
              </div>
            } @else {
              <img class="tw-flex-none tw-block tw-w-16 tw-object-contain tw-h-16 tw-rounded-full" [src]="item.imageUrl" alt="item" />
            }
            <div class="tw-flex-1">
              @if (item.id === planInfoItemId.PRODUCTS) {
                <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
                  <span i18n="@@PRODUCT_TREATMENT_KIT_WITH_COUNT">{{ regimenProductsCount }} product Treatment Kit</span>
                </h2>
                <p class="tw-font-body tw-text-200 tw-text-gray-500">
                  <span i18n="@@CUSTOMISED_KIT_PRODUCTS_WITH_COUNT">A customised kit of {{ regimenProductsCount }} products for your skin concerns.</span>
                </p>
              } @else {
                <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
                  {{ item.title }}
                </h2>
                <p class="tw-font-body tw-text-200 tw-text-gray-500">
                  {{ item.description }}
                </p>
              }
            </div>
          </section>
        </section>
        <section class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-text-black tw-mt-2 tw-mx-4 tw-py-2 tw-px-[9px]">
          <p class="tw-w-[98px] tw-text-left" i18n="@@100%Effective">100% Effective</p>
          <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
          <p class="tw-flex-1 tw-text-center" i18n="@@clinicallyTested">Clinically Tested</p>
          <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
          <p class="tw-w-[90px] tw-text-right" i18n="@@freeDelivery">Free Delivery</p>
        </section>
      </section>
      <div style="min-height: calc(env(safe-area-inset-bottom, 0px) + 110px);"></div>
    </section>
    <div class="tw-w-full tw-fixed tw-bottom-0 tw-bg-white tw-p-4 tw-pb-6 tw-z-10">
      @if (isSelectedVariantIdMatchingPlan) {
        <button class="tw-border-none tw-w-full tw-h-[54px] tw-relative tw-text-[#ffffff] tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-bg-teal-600 tw-overflow-visible tw-mb-2 tw-rounded-3"
              (click)="buyRegimen()">
          <div class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px] tw-text-orange-400">
            <svg class="tw-w-[85px] tw-h-[85px] tw-relative tw-animate-spin_slow"
                 xmlns="http://www.w3.org/2000/svg"
                 width="64.443"
                 height="67.447"
                 viewBox="0 0 64.443 67.447">
              <path id="Path_23051"
                    data-name="Path 23051"
                    d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                    transform="translate(-23.961 -186.363)"
                    fill="#D66736"></path>
            </svg>
            <span
                  class="tw-absolute tw-font-body tw-text-650 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimenDiscountBasedOnSelectedPlan}}%
              <br />Off </span>
          </div>
          <span class="tw-ml-20 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
            <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }"
                  i18n="@@buyNow">Buy Now</span>
            <span> &#64;</span>
            <span class="tw-text-200  tw-line-through">₹{{regimenMrpBasedOnSelectedPlan}}</span>
            <span>₹{{regimenPriceBasedOnSelectedPlan}}</span>
          </span>
        </button>
      } @else {
        <button csButton="outlined" type="button" class="tw-w-full" (click)="updateRegimenWithSelectedPlan(selectedPlan)">
          <span class="tw-text-300 tw-font-lexend tw-font-bold" i18n="@@selectThisPlan">Select This Plan</span>
        </button>
      }
    </div>
  </section>
} @else {
  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100" *ngIf="loading">
    <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
  </div>
  <div *ngIf="!loading" class="tw-flex tw-flex-col tw-h-full tw-font-body" [ngClass]="{ 'tw-bg-teal-100': selectedPlan === 'advance' || selectedPlan === 'introductory', 'tw-bg-orange-100': selectedPlan === 'pro', 'tw-bg-blue-100': selectedPlan === 'assist'}">
    <div class="flex-content pos-rel" #regimenModuleContainer="">
      <ng-container *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionHeader else originalHeader"></ng-container>
      <ng-template #regimenNewPropositionHeader>
        <!-- Regimen new proposition header -->
        <div class="tw-flex tw-items-center tw-px-6 tw-py-2 tw-bg-gray-800">
          <div class="tw-flex tw-shrink-0 tw-justify-center tw-items-center tw-h-10 tw-w-10 tw-bg-gray-800" (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
          </div>
          <div class="tw-flex tw-justify-center tw-items-center tw-w-full">
            <span class="tw-mr-10 tw-font-body tw-text-400 tw-text-gray-75 tw-font-normal" i18n="@@chooseTreatmentPlan">Choose
              treatment plan</span>
          </div>
        </div>
      </ng-template>
      <ng-template #originalHeader>
      <!-- Original header -->
      <div class="tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-bg-white tw-z-[100]">
        <div class="tw-fixed tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
        </div>
      </div>
      </ng-template>
      <ng-container *ngIf="tabData?.count === 2">
        <ng-container *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionTabs else originalTabs"></ng-container>
        <ng-template #regimenNewPropositionTabs>
          <!-- Regimen new proposition tabs -->
          <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'" [isRegimenNewPropositionUI]="isRegimenNewPropositionUI">
            <tab1>
              <span>{{variantsInfo[0]?.fixedPrice}}</span>
            </tab1>
            <tab2>
              <span>{{variantsInfo[1]?.fixedPrice}}</span>
            </tab2>
          </toolbar-tabs>
        </ng-template>
        <ng-template #originalTabs>
        <!-- Original tabs -->
        <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'">
          <tab1 class="tw-uppercase tw-font-bold">
            <span>3&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[0]?.fixedPrice}}</span>
          </tab1>
          <tab2 class="tw-uppercase tw-font-bold">
            <span>4&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[1]?.fixedPrice}}</span>
          </tab2>
        </toolbar-tabs>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="tabData?.count === 4">
        <ng-container *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionTabs else originalTabs"></ng-container>
        <ng-template #regimenNewPropositionTabs>
          <!-- Regimen new proposition tabs -->
          <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'" [isRegimenNewPropositionUI]="isRegimenNewPropositionUI">
            <tab1>
              <span>{{variantsInfo[0]?.fixedPrice}}</span>
            </tab1>
            <tab2>
              <span>{{variantsInfo[1]?.fixedPrice}}</span>
            </tab2>
            <tab3>
              <span>{{variantsInfo[2]?.fixedPrice}}</span>
            </tab3>
            <tab4>
              <span>{{variantsInfo[3]?.fixedPrice}}</span>
            </tab4>
          </toolbar-tabs>
        </ng-template>
        <ng-template #originalTabs>
        <!-- Original tabs -->
        <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'">
          <tab1 class="tw-uppercase tw-font-bold">
            <span>3&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[0]?.fixedPrice}}</span>
          </tab1>
          <tab2 class="tw-uppercase tw-font-bold">
            <span>4&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[1]?.fixedPrice}}</span>
          </tab2>
          <tab3 class="tw-uppercase tw-font-bold">
            <span>5&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[2]?.fixedPrice}}</span>
          </tab3>
          <tab4 class="tw-uppercase tw-font-bold" i18n="@@5Prod1to1">5 Products With 1:1 &#64; ₹{{variantsInfo[3]?.fixedPrice}}</tab4>
        </toolbar-tabs>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="tabData?.count === 3 && variantsInfo.length === 3">
        <ng-container *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionTabs else originalTabs"></ng-container>
        <ng-template #regimenNewPropositionTabs>
          <!-- Regimen new proposition tabs -->
          <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'" [isRegimenNewPropositionUI]="isRegimenNewPropositionUI">
            <tab1>
              <span>{{variantsInfo[0]?.fixedPrice}}</span>
            </tab1>
            <tab2>
              <span>{{variantsInfo[1]?.fixedPrice}}</span>
            </tab2>
            <tab3>
              <span>{{variantsInfo[2]?.fixedPrice}}</span>
            </tab3>
          </toolbar-tabs>
        </ng-template>
        <ng-template #originalTabs>
        <!-- Original tabs -->
        <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'" >
          <tab1 class="tw-uppercase tw-font-bold">
            <span>4&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[0]?.fixedPrice}}</span>
          </tab1>
          <tab2 class="tw-uppercase tw-font-bold">
            <span>5&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[1]?.fixedPrice}}</span>
          </tab2>
          <tab3 class="tw-uppercase tw-font-bold tw-px-3" i18n="@@5Prod1to1">5 Products With 1:1 &#64; ₹{{variantsInfo[2]?.fixedPrice}}</tab3>
        </toolbar-tabs>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="tabData?.count === 3 && variantsInfo.length === 4">
        <ng-container *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionTabs else originalTabs"></ng-container>
        <ng-template #regimenNewPropositionTabs>
          <!-- Regimen new proposition tabs -->
          <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'" [isRegimenNewPropositionUI]="isRegimenNewPropositionUI">
            <tab1>
              <span>{{variantsInfo[1]?.fixedPrice}}</span>
            </tab1>
            <tab2>
              <span>{{variantsInfo[2]?.fixedPrice}}</span>
            </tab2>
            <tab3>
              <span>{{variantsInfo[3]?.fixedPrice}}</span>
            </tab3>
          </toolbar-tabs>
        </ng-template>
        <ng-template #originalTabs>
        <!-- Original tabs -->
        <toolbar-tabs #toolbarTabs="" (tabSelected)="tabChange($event)" [data]="tabData" [class]="'planInfo'">
          <tab1 class="tw-uppercase tw-font-bold">
            <span>4&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[1]?.fixedPrice}}</span>
          </tab1>
          <tab2 class="tw-uppercase tw-font-bold">
            <span>5&nbsp;</span>
            <span i18n="@@products">Products</span>
            <br />
            <span>&#64; ₹{{variantsInfo[2]?.fixedPrice}}</span>
          </tab2>
          <tab3 class="tw-uppercase tw-font-bold tw-px-3" i18n="@@5Prod1to1">5 Products With 1:1 &#64; ₹{{variantsInfo[3]?.fixedPrice}}</tab3>
        </toolbar-tabs>
        </ng-template>
      </ng-container>
      <div class="tw-flex tw-flex-col">
        <ng-container
          *ngIf="isRegimenNewPropositionUI; then regimenNewPropositionTabContent else originalTabContent"></ng-container>
        <ng-template #regimenNewPropositionTabContent>
          <!-- Regimen new proposition tab content -->
          <regimen-proposition [regimenId]="regimenNewPropositionData.regimenId"
            [regimenClass]="regimenClass" [variantId]="regimenNewPropositionData.variantId"
            [totalSellingPrice]="regimenNewPropositionData.totalSellingPrice"
            [productsCount]="regimenNewPropositionData.productsCount"
            [doctorImageUrl]="regimenNewPropositionData.doctorImageUrl" />
        </ng-template>
        <ng-template #originalTabContent>
        <!-- Original tab content -->
        <h3 class="tw-text-400 tw-px-2 tw-mx-3 tw-mt-4 tw-mb-2 tw-font-bold" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.FACE" i18n="@@yourSkinTreatmentIncludes"> Your Skin Treatment kit includes </h3>
        <h5 class="tw-px-4 tw-text-gray-500 tw-mx-3 tw-mb-3 tw-capitalize" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.HAIR"> Your Hair Treatment includes </h5>
        <div class="tw-flex-1 tw-flex tw-flex-col tw-overflow-y-auto" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.FACE">
          <section class="tw-p-6 tw-pb-4 tw-bg-white tw-flex tw-flex-row tw-items-center tw-gap-6 tw-mx-3 tw-my-1 tw-shadow-z1 tw-rounded-xl" *ngFor="let service of getServicesForPlan(selectedPlan, false); let i = index;">
            <img class="tw-flex-none tw-block tw-h-24 tw-w-24 tw-bg-green-200 tw-rounded-full" *ngIf="i === 0" [src]="regimenCoverImage || service['img']" />
            <img class="tw-flex-none tw-block tw-h-24 tw-w-24 tw-bg-green-200 tw-rounded-full" *ngIf="i !== 0" [src]="service['img']" />
            <div class="tw-flex-1">
              <h2 class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-900 tw-mb-1">
                {{ service[userLanguage][0] }}
              </h2>
              <p class="tw-font-body tw-text-200 tw-text-gray-900">
                {{ service[userLanguage][1]}}
              </p>
            </div>
          </section>
        </div>
        <div class="tw-flex-1 tw-flex tw-flex-col tw-overflow-y-auto" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.HAIR">
          <section class="tw-p-6 tw-pb-4 tw-bg-white tw-flex tw-flex-row tw-items-center tw-gap-6 tw-mx-3 tw-my-1 tw-shadow-z1 tw-rounded-xl" *ngFor="let service of getServicesForPlan(selectedPlan, true); let i = index;">
            <img class="tw-flex-none tw-block tw-h-24 tw-w-24 tw-bg-green-200 tw-rounded-full" *ngIf="i === 0" [src]="regimenCoverImage || service['img']" />
            <img class="tw-flex-none tw-block tw-h-24 tw-w-24 tw-bg-green-200 tw-rounded-full" *ngIf="i !== 0" [src]="service['img']" />
            <div class="tw-flex-1">
              <h2 class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-900 tw-mb-1">
                {{ service[userLanguage][0] }}
              </h2>
              <p class="tw-font-body tw-text-200 tw-text-gray-900">
                {{ service[userLanguage][1]}}
              </p>
            </div>
          </section>
        </div>
        </ng-template>
      </div>
    </div>
  </div>
}
